<div class="login-wrapper">
  <div class="backdrop-wrapper d-flex align-items-center justify-content-center">
    <div class="login-container">
      <div *ngIf="appContext.isSunip">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="SunIP"/>
      </div>
      <div *ngIf="appContext.isForecaster">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="ChiefIP"/>
      </div>
      <div *ngIf="appContext.isLegalsight">
        <img src="{{appContext.fullLogoColor}}" style="height: 70px" title="LegalSight"/>
      </div>

      <div class="mt-3" *ngIf="!expiredLink && !redirectLoginInd && !failedReset">
        <h4 class="card-title margin-top-30">Please update your password</h4>
        <div *ngIf="!resetInd">For security reasons, please update your password to continue.</div>
        <div class="mt-5"></div>
        <townip-password-update-form [tempPassword]="tempPassword" [resetInd]="resetInd"></townip-password-update-form>
        <div class="mt-4">
          <button (click)="submitChange()" class="btn btn-primary btn-lg">{{resetInd ? 'Confirm' : 'Continue'}}</button>
          <!-- For debugging only -->
          <!--<button class="btn btn-primary" (click)="forceLogout()">Force logout</button>-->
        </div>
      </div>

      <div *ngIf="expiredLink">
        <ng-container *ngIf="passwordWasReset">
          <h4 class="card-title text-center margin-top-30">Link Expired</h4>
          <p class="text-center alert alert-warning">You may have updated your password or opened the password reset link multiple times.</p>
        </ng-container>
        <ng-container *ngIf="!passwordWasReset">
          <h4 class="card-title text-center margin-top-30">Sorry, your reset password link has expired!</h4>
          <p>You can send another reset password link by clicking the button below.</p>
          <div class="text-center margin-bottom-30">
            <button label="Forgot Password" (click)="forgotPassword()" pButton class="raised-button ui-button-success"></button>
          </div>
        </ng-container>
      </div>

      <div *ngIf="failedReset">
        <h4 class="card-title text-center margin-top-30">Sorry, your reset password failed!</h4>
        <p>You can send another reset password link by clicking the button below.</p>
        <div class="text-center margin-bottom-30">
          <button label="Forgot Password" (click)="forgotPassword()" pButton class="raised-button ui-button-success"></button>
        </div>
      </div>

      <div *ngIf="redirectLoginInd">
        <townip-standard-alert class="margin-top-30" type="success" mode="lite">
          Your password was successfully reset!
        </townip-standard-alert>
        <button type="button" class="btn btn-primary btn-lg margin-top-30" (click)="redirectLogIn()">Login</button>
      </div>
    </div>
  </div>
</div>

